export default __webpack_public_path__ + "static/media/blog-cover.99ad4fc9.jpg";